import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class SwiperResizeDispatcherService {
  private readonly _dispatcher$$ = new Subject<void>()

  readonly dispatcher$ = this._dispatcher$$.asObservable()

  forceResize() {
    this._dispatcher$$.next()
  }
}
